import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http'; 

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotFoundComponent } from './parcial/not-found/not-found.component';

import { AuthGuard } from './auth-guard.service';
import { AuthService } from './auth.service';
import { JwtHelperService, JWT_OPTIONS  } from '@auth0/angular-jwt';

import { JwtRequestService } from './jwt-request.service';

import { WildcardRoutingModule } from './wildcard-routing.module';
import { HubModule } from './hub/hub.module';
import { MenuModule } from './menu/menu.module';
import { PerfilModule } from './perfil/perfil.module';
import { PerfilEditModule } from './perfil/perfil-edit.module';
import { BloquearPantallaModule } from './bloquear-pantalla/bloquear-pantalla.module';
import { PipesModule }             from './pipes/pipes.module';
import { IndexModule } from './index/index.module';

//Sistema
import { UsuariosModule } from './sistema/usuarios/usuarios.module';
import { GruposModule } from './sistema/grupos/grupos.module';
import { ModulosModule } from './sistema/modulos/modulos.module';
import { SisDashboardModule } from './sistema/dashboard/sis-dashboard.module';
import { SisReporteModule } from './sistema/reporte/sis-reporte.module';
import { EmpresaModule } from './sistema/empresa/empresa.module';
import { SucursalModule } from './sistema/sucursal/sucursal.module';
import { ConfiguracionEmpresaModule } from './sistema/configuracion-empresa/empresa.module';
import { ConfiguracionSucursalModule } from './sistema/configuracion-sucursal/sucursal.module';

import { CatalogoCajaModule } from './catalogos/catalogo-caja/catalogo-caja.module';
import { NivelEducativoModule } from './catalogos/nivel-educativo/nivel-educativo.module';

//catalogos
import { TipoMedioModule } from './catalogos/tipo-medio/tipo-medio.module';
import { TipoPersonaModule } from './catalogos/tipo-persona/tipo-persona.module';
import { TipoRedSocialModule } from './catalogos/tipo-red-social/tipo-red-social.module';
import { PaisModule } from './catalogos/pais/pais.module';
import { EstadoModule } from './catalogos/estado/estado.module';
import { MunicipioModule } from './catalogos/municipio/municipio.module';
import { ProveedorModule } from './catalogos/proveedor/proveedor.module';
import { ClienteModule } from './catalogos/cliente/cliente.module';
import { EmpleadoModule } from './catalogos/empleado/empleado.module';
import { PresentacionModule } from './catalogos/presentacion/presentacion.module';
import { UnidadMedidaModule } from './catalogos/unidad-medida/unidad-medida.module';
import { CategoriaModule } from './catalogos/categoria/categoria.module';
import { ImpuestoModule } from './catalogos/impuesto/impuesto.module';



import { PreinscripcionModule } from './promocion/preinscripcion/preinscripcion.module';
import { DocenteModule } from './personal/docente/docente.module';
import { AdministrativoModule } from './personal/administrativo/administrativo.module';

import { TipoMovimientoModule } from './catalogos/tipo-movimiento/tipo-movimiento.module';
import { TipoMetodoPagoModule } from './catalogos/tipo-metodo-pago/tipo-metodo-pago.module';
import { TipoFormaPagoModule } from './catalogos/tipo-forma-pago/tipo-forma-pago.module';
import { TipoFlujoEfectivoModule } from './catalogos/tipo-flujo-efectivo/tipo-flujo-efectivo.module';
import { TipoBajaModule } from './catalogos/tipo-baja/tipo-baja.module';
import { CatalogoIncidenciaModule } from './catalogos/catalogo-incidencia/catalogo-incidencia.module';

//transacciones
import { CajaModule } from './transaccion/caja/caja.module';


//control escolar
import { AlumnoModule } from './control-escolar/alumno/alumno.module';
import { GrupoModule } from './control-escolar/grupo/grupo.module';
import { CalificacionModule } from "./control-escolar/calificacion/calificacion.module";
import { CalificacionGrupoModule } from "./control-escolar/calificacion-grupo/calificacion-grupo.module";
import { AvanzarGrupoModule } from './control-escolar/avanzar-grupo/avanzar-grupo.module';


import { SecretariaEducacionModule } from "./control-escolar/secretaria-educacion/secretaria-educacion.module";
//import { SecretariaEducacionFederalModule } from "./control-escolar/secretaria-educacion-federal/secretaria-educacion-federal.module";
import { TitulacionModule } from "./control-escolar/titulacion/titulacion.module";

import { AnexoOchoModule } from './control-escolar/anexo-ocho/anexo-ocho.module';  

//coordinacion academica
import { ModalidadModule } from './coordinacion-academica/modalidad/modalidad.module';
import { PeriodoEscolarModule } from './coordinacion-academica/periodo-escolar/periodo-escolar.module';
import { CicloEscolarModule } from './coordinacion-academica/ciclo-escolar/ciclo-escolar.module';
import { CarreraModule } from './coordinacion-academica/carrera/carrera.module';
import { MateriaModule } from './coordinacion-academica/materia/materia.module';
import { MateriaCostoModule } from './coordinacion-academica/materia-costo/materia-costo.module';
import { PracticaModule } from './coordinacion-academica/practica/practica.module';
import { PlanEstudioModule } from './coordinacion-academica/plan-estudio/plan-estudio.module';
import { HorarioModule } from './coordinacion-academica/horario/horario.module';
import { HorarioLayoutModule } from "./coordinacion-academica/horario-layout/horario-layout.module";

// temporal el adeudo update
import { AdeudoManualModule } from './coordinacion-academica/adeudo-manual/adeudo.module';

import { CarreraPlanModule } from './coordinacion-academica/carrera-plan/carrera-plan.module';
import { CarreraPlanModuloModule } from './coordinacion-academica/carrera-plan-modulo/carrera-plan-modulo.module';
import { CategoriaMateriaModule } from './coordinacion-academica/categoria-materia/categoria-materia.module';

//servicios financieros
import { ColegiaturaModule } from './servicio-financiero/colegiatura/colegiatura.module';
import { ServicioModule } from './servicio-financiero/servicios/servicio.module';
import { PlanesPagosModule } from './servicio-financiero/planes-pagos/planes-pagos.module';
import { BecasModule } from './servicio-financiero/becas/becas.module';
import { InscripcionModule } from './servicio-financiero/inscripcion/inscripcion.module';
import { PagosModule } from './servicio-financiero/pagos/pagos.module';
import { CuentasBancariasModule } from './servicio-financiero/cuenta-bancaria/cuenta-bancaria.module';
import { BancosModule } from './servicio-financiero/banco/banco.module';
import { PagosPublicosModule } from "./servicio-financiero/pagos-publicos/pagos-publicos.module";


//Inventario
import { ArticuloModule } from './invetario/articulo/articulo.module';

//reportes
import { ReporteResumenModule } from './reporte/resumen/reporte-resumen.module';
import { ReporteInventarioModule } from './reporte/inventario/reporte-inventario.module';
import { ReporteGraficoModule } from './reporte/grafico/reporte-grafico.module';
import { ReporteDetalladoModule } from './reporte/detallado/reporte-detallado.module';

//Notificacion Pusher
import { NotificacionPusherModule } from './notificacion/notificacion-pusher.module';

//facturacion
import { FacturacionModule } from './servicio-financiero/facturacion/facturacion.module';

//Eventos
import { EventoCategoriaModule } from './eventos/categoria/evento-categoria.module';
import { EventoModule } from "./eventos/evento/evento.module";
import { FormularioModule } from "./formulario/configuracion-formulario/formulario.module";
import { FSCamposCatalogosModule } from "./formulario/fs-campo-catalogo/fs-campos-catalogos.module";
import { DocumentosModule } from "./formulario/documento/documento.module";
import { VentaModule } from './transaccion/venta/venta.module';
import { DashboardEscolarModule } from './sistema/dashboard-escolar/dashboard-escolar.module';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    NotFoundComponent,   
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,

    FormsModule,
    HttpClientModule,

    HubModule,
    MenuModule,
    IndexModule,
    PerfilModule,
    PerfilEditModule,
    BloquearPantallaModule,
    PipesModule,
    UsuariosModule,
    GruposModule,
    ModulosModule,
    SisDashboardModule,
    SisReporteModule,
    EmpresaModule,
    SucursalModule,
    ConfiguracionEmpresaModule,
    ConfiguracionSucursalModule,
    TipoMedioModule,
    TipoPersonaModule,
    TipoRedSocialModule,
    PaisModule,
    EstadoModule,
    MunicipioModule,
    ProveedorModule,
     
    //control escolar
    AlumnoModule,
    GrupoModule,
    CalificacionModule,
    CalificacionGrupoModule,
    AvanzarGrupoModule,
    SecretariaEducacionModule,
    //SecretariaEducacionFederalModule,
    TitulacionModule,
    AnexoOchoModule,
    PeriodoEscolarModule,
    CarreraModule,
    PlanEstudioModule,

    //coordinacion academica
    CicloEscolarModule,
    ModalidadModule,
    CarreraPlanModule,
    CarreraPlanModuloModule,
    MateriaModule,
    MateriaCostoModule,
    PracticaModule,
    CategoriaMateriaModule,
    HorarioModule,
    HorarioLayoutModule,
    //servicios financieros
    ColegiaturaModule,
    ServicioModule,
    PlanesPagosModule,
    BecasModule,
    InscripcionModule,
    PagosModule,
    CuentasBancariasModule,
    BancosModule,
    PagosPublicosModule,

    PreinscripcionModule,
    DocenteModule,
    AdministrativoModule,
     
    ClienteModule,
    EmpleadoModule,
    PresentacionModule,
    UnidadMedidaModule,
    CategoriaModule,
    CatalogoCajaModule,
    NivelEducativoModule,
    TipoMovimientoModule,
    TipoMetodoPagoModule,
    TipoFormaPagoModule,
    TipoFlujoEfectivoModule,
    TipoBajaModule,
    CatalogoIncidenciaModule,
    CajaModule,
    VentaModule,
    ArticuloModule,
    ImpuestoModule,
    DocumentosModule,

    ReporteResumenModule,
    ReporteInventarioModule,
    ReporteGraficoModule,
    ReporteDetalladoModule,

    NotificacionPusherModule,

    FacturacionModule,

    //EVENTOS
    EventoCategoriaModule,
    EventoModule,
    FormularioModule,
    FSCamposCatalogosModule,

     // Lili
     DashboardEscolarModule,
    
     WildcardRoutingModule,

   

   // Este siempre debe ir al final para que no haga conflicto con otras rutas
  ],
  providers: [
    Title, 
    AuthGuard, 
    AuthService, 
    JwtRequestService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService, 
    {
      provide: LocationStrategy, useClass: HashLocationStrategy 
    }
  ] ,
  bootstrap: [AppComponent]
})
export class AppModule { }
